import React, { useState, useEffect } from 'react';
import { Alert, Fade } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const ErrorToolbar = ({ message = "❌ Something went wrong!", delay = 5000 }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <Fade in={show} unmountOnExit>
      <Alert
        variant="danger"
        onClose={() => setShow(false)}
        dismissible
        className="text-center fixed-top mb-0 rounded-0"
        style={{ zIndex: 1050 }}
      >
        {message}
      </Alert>
    </Fade>
  );
};

ErrorToolbar.propTypes = {
  message: PropTypes.string,
  delay: PropTypes.number,
};
